
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/conference/[eventId]/booth/new",
      function () {
        return require("private-next-pages/admin/conference/[eventId]/booth/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/conference/[eventId]/booth/new"])
      });
    }
  